import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';

declare let dojoApp: any;

@Component({
    selector: 'dojo-paybills',
    templateUrl: './dojo-paybills.component.html'
})
export class DojoPayBillsComponent implements OnInit, OnDestroy {
    appSettings: any;
    constructor(private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.appSettings = appSettings;
    }

    ngOnInit() {
        this.loadPayBillsContent();
    }

    ngOnDestroy(): void {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyBillSuite();
        }
    }

    loadPayBillsContent() {
        this.nxiRestService.getNxiPayBillsRestResponse('billsuite').subscribe(
            resp => {
                console.log('Retrived billsuite params : ', resp);
                resp.advisor = this.appSettings.isAdvisor;
                if (dojoApp) {
                    dojoApp.renderBillSuite(resp);
                }
            }
        );
    }
}
